import IncidentForm from "../../../../components/Forms/incidentForm";
import { TabOptions } from "../../../../types/fieldInstance.interface";

const Details = () => {
  return (
    <div>
      <IncidentForm tabTitle={TabOptions.Details} />
    </div>
  );
};

export default Details;
